module.exports = __webpack_public_path__ + "img/ananya.7f7e9992.jpeg";